import React, { useEffect, useState, useRef, useMemo } from "react";
import { Modal, Badge, Button, Alert } from "react-bootstrap";
import { Bell } from "lucide-react";
import apiClient from "../../business/network/ApiClient";
import { FaTrash, FaExclamationCircle } from "react-icons/fa";
import utils from "../../business/helper/Utils";
import { GrtAnalyticsGA4 } from "./GrtAnalyticsGA4";

const MessageNotification = ({ onSelected, refresh, setScheduledData, setScheduledStatus }) => {
  const [messageCount, setMessageCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [threads, setThreads] = useState([]);
  const [userData, setUserData] = useState(null);
  const [threadToDelete, setThreadToDelete] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const intervalRef = useRef(null);
  // Set once the first list has arrived: the panel shows "loading" only before that, so the
  // 10-minute refresh and the re-read after a delete never blank a list that is already there.
  const loadedOnceRef = useRef(false);

  const handleAnalytics = (ga) => {
    if (ga) {
      setAnalytics(ga);
    }
  };

  const handleDelete = async (thread) => {
    setThreadToDelete(thread);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (threadToDelete) {
      try {
        await apiClient.deleteScheduledQuestion(
          threadToDelete?.scheduledQuestion?.id
        );

        fetchThreads();
      } catch (error) {
        console.error("Failed to delete task", error);
      }
      analytics?.trackEventAnalytics(
        "MessageNotification",
        "DeleteThread",
        "click"
      );
    }
    setShowDeleteConfirm(false); // Close the confirmation modal
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false); // Close the confirmation modal
  };

  useEffect(() => {
    try {
      console.log("Setting user data in MessageNotification");

      const process = () => {
        const token = localStorage.getItem("Token");
        //console.log(token);
        if (token) {
          const tokenData = JSON.parse(token);
          const udata =
            typeof tokenData.userData === "string"
              ? JSON.parse(tokenData.userData)
              : tokenData.userData;
          if (udata.length > 0 || (udata && udata.userId)) {
            let userDataObject = Array.isArray(udata) ? udata[0] : udata;
            console.log("userDataObject", userDataObject);
            setUserData(userDataObject);
            return !!userDataObject?.userId;
          }
        }
        return false;
      }
      const willFetch = process();
      // No user to fetch for: the panel must not wait for a list that will never come.
      if (!willFetch) setScheduledStatus?.("ready");
      console.log("User data set in MessageNotification");
    } catch (error) {
      console.error("Error parsing token", error);
      setScheduledStatus?.("ready");
    }
  }, []);

  const fetchThreads = async () => {
    if (!userData?.userId) return;
    console.log("Fetching threads at:", new Date());
    if (!loadedOnceRef.current) setScheduledStatus?.("loading");
    try {
      const data = await apiClient.getScheduledQuestions(userData.userId);
      const list = Array.isArray(data) ? data : [];
      loadedOnceRef.current = true;
      setThreads(list);
      setScheduledData(list);
      setMessageCount(list.length);
      setScheduledStatus?.("ready");
    } catch (error) {
      console.error("Failed to fetch threads", error);
      setScheduledStatus?.("error");
    }
  };

  useEffect(() => {

    console.log("userData", userData);
    if (!userData?.userId) return;

    fetchThreads();

    console.log("Setting interval for threads alerts to 10 minutes.");
    intervalRef.current = setInterval(fetchThreads, 600000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [userData]);

  useEffect(() => {
    if (refresh) {
      fetchThreads();
    }
  }, [refresh]);

  const handleThreadClick = (thread) => {
    setShowModal(false);
    onSelected(thread);
  };

  const getUnreadThreads = useMemo(
    () => threads?.filter((p) => p?.scheduledQuestion?.readed === false).length,
    [threads]
  );

  return (
    <>
      {threads && Array.isArray(threads) && !!getUnreadThreads && (
        <div
          className="bg-red-100 rounded-full text-minimal text-white font-bold font-notosans w-4 h-4 flex items-center justify-center absolute top-1 right-1"
          onClick={() => {
            if (messageCount > 0) setShowModal(true);
          }}
        >
          &nbsp;
          {
          //getUnreadThreads()
          }          
        </div>
      )}
      <GrtAnalyticsGA4 onLoaded={handleAnalytics} />
    </>
  );
};

export default MessageNotification;
